import eduKakaoSync from '@/views/qr/eduKakaoSync'
import showRecoEvent from '@/views/qr/showRecoEvent'

export default [
    {
        path: '/eduKakaoSync',
        name: 'edu-kakao-sync',
        component: eduKakaoSync,
        meta: {
            auth: true,
            logging: true, 
            pageName: 'QR CODE' 
        }
    },
    {
        path: '/showRecoEvent',
        name: 'edu-reco-event',
        component: showRecoEvent,
        meta: {
            auth: true,
            logging: true, 
            pageName: 'RECO EVENT' 
        }
    }
]